<template>
	<div>
		<div v-if="jsonCurso.length == 0" style="margin-bottom: 250px;"></div>
		<div v-else class="container-fluid">
			<div class="row">
				<div class="col-xl-4">
					<div class="card">
						<div class="card-body">
							<div class="card-header bg-transparent p-3">
								<h5
									class="header-title mb-0"
									v-if="jsonCurso.tituloCurso" 
								>
									#{{ jsonCurso.idCurso }}
									{{ jsonCurso.tituloCurso }}
								</h5>
								<PuSkeleton v-else />
								<div
									class="media-body"
									v-if="jsonProfesor.nombre"
								>
									<label
										>Profesor: {{ jsonProfesor.nombre }}
										{{ jsonProfesor.apellido }}</label
									><br />
									<label>
										Coordinadora:
										{{ jsonCoordinadora.nombre }}
										{{ jsonCoordinadora.apellido }}
									</label>
								</div>
								<PuSkeleton v-else />
							</div>
							<ul class="list-group list-group-flush">
								<li class="list-group-item">
									<div class="media-body">
										<h5 class="header-title mb-4">
											Módulos
										</h5>
										<b-alert
											v-if="loadModulos && !jsonModulo[0]"
											show
											variant="warning"
											>No existen módulos.</b-alert
										>
										<ul id="example-2">
											<li
												v-for="(modulo,
												index) in jsonModulo"
												:key="index"
											>
												{{ modulo.nombre }}
												<p class="text-muted mb-2">
													Inicio:
													{{
														formatoFecha(
															modulo.fechaHabilitacion
														)
													}}
												</p>
											</li>
										</ul>

										<PuSkeleton
											v-if="!loadModulos"
											:count="2"
											>{{ modulos[0] }}</PuSkeleton
										>
										<hr />
									</div>

									<div class="media-body mb-4">
											<h5 class="header-title mb-4">
												Herramientas
											</h5>
											<template >
												<b-button 
													variant="outline-info"
													v-b-modal.modal-recalcularPromedio
													@click="modalRecalularPromedios()"
												>
												Recalcular Promedio
												</b-button>
											</template>
									</div>
									<div class="media-body">
										<h5 class="header-title mb-4">
											Evaluaciones
										</h5>
										<b-table
											v-if="jsonEvaluacion[0]"
											:items="jsonEvaluacion"
											:fields="fields"
											class="mt-3"
											striped
											hover
											outlined
										>
											<template
												v-slot:cell(nombre)="data"
											>
												<router-link :to="'/info-evaluacion/' + data.item.id">{{ data.value }}</router-link>
											</template>
											<template v-slot:cell(opciones)="data">
													<b-button 
														variant="outline-info"
														v-b-modal.modal-reinicioControl
														@click="modalReinicioControl(data.item)"
													>
													Reinicio Masivo
													</b-button>
											</template>
										</b-table>
										<b-alert
											v-if="
												loadEvaluacion &&
													!jsonEvaluacion[0]
											"
											show
											variant="warning"
										>
											No existen evaluaciones.
										</b-alert>
										<PuSkeleton
											v-if="!loadEvaluacion"
											:count="2"
											>{{ items[0] }}</PuSkeleton
										>
										<!-- <hr />
										<h5>Reinicio individual</h5>
										<router-link class="btn btn-outline-info"  :to="'/reinicio-nota/' + this.jsonCurso.idCurso"> Reinicio Notas Individual</router-link> -->
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<!-- end col -->
				<div class="col-xl-8">
					<div class="card">
						<div class="card-body">
							<h5>
								<i class="fas fa-users"></i> Detalle evaluaciones
							</h5>
							<tablaAlumno></tablaAlumno>
							<!-- 	<PuSkeleton v-else :count="5" /> -->
						</div>
					</div>
				</div>
				<!-- end col -->
			</div>
		</div>
		<reinicioControl ref="reinicioControl" />
		<recalcularPromedio ref="recalcularPromedio" />
	</div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import tablaAlumno from "@/components/evaluacion/tablaAlumno";
import fechaComponent from "@/components/fechaConversionComponent";
import reinicioControl from "@/components/evaluacion/modal/renicioControl";
import recalcularPromedio from "@/components/evaluacion/modal/recalcularPromedio";
export default {
	components: {
		tablaAlumno,
		reinicioControl,
		recalcularPromedio,
	},
	data() {
		return {
			profesor: "",
			modulos: "",
			loadTablaAlumno: true,
			items: [],
			fields: ["nombre", "exigencia", "opciones"],
		};
	},
	methods: {
		modalReinicioControl(data) {
			this.$refs.reinicioControl.getInfo(data);
		},

		modalRecalularPromedios(){
			this.$refs.recalcularPromedio.getInfo(this.jsonCurso.idCurso);
		},

		formatoFecha(fecha) {
			return fecha ? this.fechaFinal(fecha) : "-";
		},
		fechaFinal(fechaCurso) {
			//Formato fecha es año-mes-dia
			var objDate = new Date(fechaCurso);

			const dia = objDate.toLocaleDateString("es-ES", { day: "numeric" }),
				mes = objDate.toLocaleDateString("es-ES", { month: "long" }),
				año = objDate.toLocaleDateString("es-ES", { year: "numeric" });

			return dia + " " + mes + " " + año;
		},
	},
	computed: {
		...mapState("curso", ["jsonCurso"]),
		...mapState("modulo", ["jsonModulo"]),
		...mapState("profesor", ["jsonProfesor"]),
		...mapState("alumno", ["jsonCoordinadora"]),
		...mapState("modulo", ["jsonModulo"]),
		...mapState("evaluacion", ["jsonEvaluacion"]),
		loadModulos() {
			return this.jsonModulo ? true : false;
		},
		loadEvaluacion() {
			return this.jsonEvaluacion ? true : false;
		},
	},
};
</script>
